export default function() {
	$("#unsubscribeModal").modal('show');

	$(".unsubscribe-form").on('submit', function(e) {
		e.preventDefault();
		var form = $(this),
			btn = form.find('.btn-primary'),
			data = form.serializeJSON();

		if(form.data('submitting') === true) {
			return;
		}

		// if(!('unsubscribe' in data)) {
		// 	alert("Please choose an unsubscribe option");
		// 	return;
		// }

		form.data('submitting', true);
		btn.button('loading').prop('disabled', true);

		data.currentRoute = config.route;

		ajax(form.data('action'), data, function(r) {
			popup(r.message, function() {
				document.location = config.url.base + 'GreatOffersForYou';
			});
		}, function() {
			btn.button('reset').prop('disabled', false);
			form.data('submitting', false);
		});
	});
};
